import { render, staticRenderFns } from "./absence.vue?vue&type=template&id=07b4048a&scoped=true&"
import script from "./absence.vue?vue&type=script&lang=js&"
export * from "./absence.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07b4048a",
  null
  
)

export default component.exports